import { useEffect, useState, useContext, useRef } from "react";
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';

import {
  createUser,
  updateUser,
  getRoles,
  apiClient,
  getShops,
  getWarehouses,
  createDocumentsTable
} from "../../../Utility/Api";
import { formatDate, formatDate2, validateDates } from "../../../Utility/function";

export const AddUser = ({ showModal, setShowModal, fetchUser }) => {
  const { showLoader, hideLoader, UserItem, shopItem, selectedWarehouse } = useContext(WarehouseContext);
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    role_id: "",
    status: "1",
    image: "",
    stamp: "1",
    sign_image: "1",
    // password: "TTIMS@123",
    password: "KABEER@1998",
    employee_id: "",
    date_join: "",
    designation: "",
    id_card_no: "",
    shop_id: shopItem?.user_id,
    created_by: UserItem?.user_id,
  });
  const [warehouse, setWarehouse] = useState(0);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [docserrors, setDocsErrors] = useState({});
  const [Shops, setShops] = useState([]);
  const [localshop, setlocalshop] = useState(shopItem);
  const [user, setUser] = useState(UserItem)

  useEffect(() => {
    fetchRoles();
    fetchShops()
    fetchWarehouses()
  }, []);

  const fetchWarehouses = async () => {
    try {
      const response = await getWarehouses();
      if (response && response.data) {
        setWarehouse(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    }
  };

  const fetchShops = async (page = 1, text = "") => {
    try {
      const response = await getShops(page, text);
      if (response.data && response.data.data) {
        setShops(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await getRoles();
      setRoles(response.data.data);
    } catch (error) {
      toast.error("Failed to fetch roles");
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setErrors({
      full_name: "",
      email: "",
      phone: "",
      role_id: "",
      image: "",
      status: "",
      password: "",
    });
    setFormData({
      full_name: "",
      email: "",
      phone: "",
      image: "",
      role_id: "",
      status: "",
      password: "",
    });
  };

  const handleSubmit = async (e) => {
    showLoader()

    //  const validationErrors = {};

    // // if (documentData.length == 0) {
    // //   validationErrors.documentData = "Document is required.";
    // // }
    // if (!formData.full_name) {
    //   validationErrors.full_name = "Name is required.";
    // }
    // // if (!formData.email) {
    // //   validationErrors.email = "Email is required.";
    // // }
    // if (!formData.id_card_no) {
    //   validationErrors.id_card_no = "card is required.";
    // }
    // // if (!formData.phone) {
    // //   validationErrors.phone = "phone number is required.";
    // // }
    // if (!formData.role_id) {
    //   validationErrors.role_id = "Role title is required.";
    // }
    // if (!formData.employee_id) {
    //   validationErrors.employee_id = "Employee id is required.";
    // }
    // if (!formData.date_join) {
    //   validationErrors.date_join = "Date join is required.";
    // }
    // if (!formData.designation) {
    //   validationErrors.designation = "Designation is required.";
    // }

    // if (Object.keys(validationErrors).length > 0) {
    //   setErrors(validationErrors);
    //   hideLoader()
    //   return;
    // }
    // const requiredFields = [
    //   { key: "full_name", label: "Full Name" },
    //   // { key: "email", label: "Email" },
    //   // { key: "phone", label: "Phone Number" },
    //   { key: "role_id", label: "Role" },
    //   { key: "id_card_no", label: "ID Card Number" },
    // ];

    // // Find which fields are missing
    // const missingFields = requiredFields
    //   .filter((field) => !formData[field.key])
    //   .map((field) => field.label);

    // if (missingFields.length > 0) {
    //   toast.error(
    //     `Please fill in the following fields: ${missingFields.join(", ")}`
    //   );
    //   return;
    // }

    const validationErrors = {};
    if (!formData.full_name?.trim()) {
      validationErrors.full_name = "Name is required.";
    }
    if (!formData.role_id) {
      validationErrors.role_id = "Role title is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }

    const formDataPayload = new FormData();
    var payload = formData;
    payload.shop_id = shopItem?.shop_id;
    payload.warehouse_id = selectedWarehouse?.id;
    console.log("Payload", payload)
    if (formData.role_id !== "1" && formData.role_id !== 1) {
      delete formData.stamp;
      delete formData.sign_image;
    }

    Object.keys(formData).forEach((key) => {
      if (key === "image" || key === "stamp" || key === "sign_image") {
        if (formData[key] instanceof File) {
          formDataPayload.append(key, formData[key]);
        }
      } else if (key === "phone" && !formData[key]) {
        // Do not append phone if it is empty so the backend won't overwrite password
      } else {
        formDataPayload.append(key, formData[key]);
      }
    });



    var docsPayload = documentData;

    try {
      var response = await createUser(formDataPayload);
      if (response.data?.data) {
        var resdata = response.data.data;
        console.log("resdata", resdata)

        await docsPayload?.map(async (item, index) => {
          const uploadData = new FormData();
          uploadData.append("title", item.title);
          uploadData.append("description", item.description);
          uploadData.append("file_upload", item.file);
          uploadData.append("issued_date", item.issued_date);
          uploadData.append("expiry_date", item.expiry_date);
          uploadData.append("document_type_id", 1);
          uploadData.append("emp_id", resdata.id);
          uploadData.append("date", new Date().toISOString().split("T")[0]); // Current date
          uploadData.append("shop_id", shopItem?.shop_id || "");
          await createDocumentsTable(uploadData);
        })
      }

      toast.success("User Added successfully");
      setShowModal(false);
      hideLoader()
      fetchUser();
      setFormData({
        full_name: "",
        email: "",
        phone: "",
        role_id: "",
        image: "",
        status: "",
        password: "",
      });
      setDocumentData([]);
      setCurrentStep(1)
    } catch (error) {
      console.error("Error saving User data:", error.response?.data.message);
      hideLoader()

      toast.error(error.response?.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData({
        ...formData,
        [name]: numericValue,
      });
      return;
    }

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const emailErrorElement = document.getElementById("emailError");
      if (!emailPattern.test(value)) {
        emailErrorElement.style.display = "block"; // Show error message
      } else {
        emailErrorElement.style.display = "none"; // Hide error message
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const filteredShops = user?.role_title === "Super Admin"
    ? Shops
    : Shops?.filter(shop => shop?.shop_id == localshop?.shop_id);

  const [currentStep, setCurrentStep] = useState(1);

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleNext = () => {

    // if (currentStep == 1 && (!formData.full_name || !formData.id_card_no || !formData.role_id || !formData.employee_id || !formData.date_join || !formData.designation)) {
    //   toast.error("Required all fields");
    //   return;
    // }
    // if (currentStep == 1) {
    //   const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    //   const emailErrorElement = document.getElementById("emailError");
    //   // if (!emailPattern.test(formData.email)) {
    //   if (false) {
    //     emailErrorElement.style.display = "block";
    //     return;
    //   } else {
    //     emailErrorElement.style.display = "none";
    //   }
    // }

    // // if (currentStep == 1 && (!formData.phone || formData.phone.length < 8)) {
    // //   if (!formData.phone) {
    // //     toast.error("Phone number is required.");
    // //   } else {
    // //     toast.error("Phone number must be at least 8 digits long.");
    // //   }
    // //   return;
    // // }
    setCurrentStep(currentStep + 1);
  };

  const fileInputRef = useRef(null);
  const [documentData, setDocumentData] = useState([]);
  const [docsData, setDocsData] = useState({
    title: "",
    description: "",
    issued_date: "",
    file: null,
    expiry_date: "",
  });

  const handleChangeDocs = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setDocsData({ ...docsData, [name]: files[0] });
    } else {
      setDocsData({ ...docsData, [name]: value });
    }
    setErrors({});
  };

  const handleAddDocsRow = () => {
    console.log(docsData)
    if ((currentStep == 2 || true) && (!docsData.title || !docsData.issued_date || !docsData.expiry_date)) {
      toast.error("Required all fields");
      return;
    }
    if ((currentStep == 2 || true) && docsData.issued_date && docsData.expiry_date) {
      var error = validateDates(formatDate2(docsData.issued_date), formatDate2(docsData.expiry_date), 'issued', 'expiry', true);
      if (error) {
        toast.error(error);
        return;
      }
    }
    setDocumentData([...documentData, docsData]);
    setDocsData({
      title: "",
      description: "",
      issued_date: "",
      file: null,
      expiry_date: "",
    })
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input
    }

  }

  const handleRemoveRow = (index) => {
    const updatedRows = documentData.filter((_, rowIndex) => rowIndex !== index);
    setDocumentData(updatedRows);
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {/* {currentStep === 1 ? "User" : "Document"} */}
                  Add User
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                {/* Step indicator commented out */}
                {/* 
                <div className="step-indicator mb-5 mt-3">
                  <span className={`step ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : ''}`}>1</span>
                  <span className={`step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`}>2</span>
                </div>
                */}

                {/* Step 1 Fields rendered unconditionally */}
                {true && (
                  <>
                    <div className="form-group mb- d-flex justify-content-center align-items-center">
                      <div
                        className="profile-pic d-flex justify-content-center align-items-center rounded-circle"
                        onClick={() =>
                          document.getElementById("image-upload").click()
                        }
                        style={{
                          width: "100px",
                          height: "100px",
                          overflow: "hidden",
                          border: "2px solid #ccc",
                          cursor: "pointer",
                          backgroundColor: "#f8f8f8",
                        }}
                      >
                        {formData.image ? (
                          <img
                            src={URL.createObjectURL(formData.image)}
                            className="rounded-circle"
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <img
                            src="../../assets/images/profile.png" // Replace with your default icon URL
                            alt="Default Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                      <input
                        id="image-upload"
                        type="file"
                        name="image"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            image: e.target.files[0],
                          })
                        }
                        className="form-control d-none" // Hide the input field
                      />
                    </div>

                    <div className="form-group row">
                      <div className="form-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Employee ID</label>
                        <input
                          type="text"
                          name="employee_id"
                          value={formData.employee_id}
                          onChange={handleChange}
                          className="form-control"
                        />
                        {errors.employee_id && (
                          <small className="text-danger">{errors.employee_id}</small>
                        )}
                      </div>
                      <div className="form-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>FullName</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          className="form-control"
                        />
                        {errors.full_name && (
                          <small className="text-danger">{errors.full_name}</small>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="form-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                        />

                        <div className="">
                          <small
                            id="emailError"
                            className="text-danger"
                            style={{ display: "none" }}
                          >
                            Please enter a valid email.
                          </small>
                        </div>
                      </div>

                      <div className="form-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Phone</label>
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="form-control"
                        />
                        {errors.phone && (
                          <small className="text-danger">{errors.phone}</small>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="orm-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Date Of Join</label>
                        <input
                          type="date"
                          name="date_join"
                          value={formatDate2(formData.date_join)}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ["date_join"]: formatDate(e.target.value),
                            });
                          }}
                          className="form-control"
                        />
                        {errors.date_join && (
                          <small className="text-danger">{errors.date_join}</small>
                        )}
                      </div>
                      <div className="orm-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Designation</label>
                        <input
                          type="text"
                          name="designation"
                          value={formData.designation}
                          onChange={handleChange}
                          className="form-control"
                        />
                        {errors.designation && (
                          <small className="text-danger">{errors.designation}</small>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="orm-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>ID Card</label>
                        <input
                          type="text"
                          name="id_card_no"
                          value={formData.id_card_no}
                          onChange={handleChange}
                          className="form-control"
                        />
                        {errors.id_card_no && (
                          <small className="text-danger">{errors.id_card_no}</small>
                        )}
                      </div>
                      <div className="orm-group col-sm-12 col-lg-6 col-md-6 mb-3">
                        <label>Role</label>
                        <select
                          name="role_id"
                          value={formData.role_id}
                          onChange={handleChange}
                          className="form-control"
                          required
                        >
                          <option value="">Select Role</option>
                          {roles.map((role) => (
                            <option key={role.role_id} value={role.role_id}>
                              {role.role_title}
                            </option>
                          ))}
                        </select>
                        {errors.role_id && (
                          <small className="text-danger">{errors.role_id}</small>
                        )}
                      </div>
                    </div>
                    {formData.role_id == 1 &&
                      <div className="row">
                        <div className="col-md-6 form-group mb-3">
                          <label>Stamp</label>
                          <input
                            id="image-upload"
                            type="file"
                            name="stamp"
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                stamp: e.target.files[0],
                              })
                            }
                            className="form-control" // Hide the input field
                          />
                        </div>
                        <div className="col-md-6 form-group mb-3">
                          <label>Sign</label>
                          <input
                            id="image-upload"
                            type="file"
                            name="sign_image"
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                sign_image: e.target.files[0],
                              })
                            }
                            className="form-control " // Hide the input field
                          />
                        </div>
                      </div>
                    }

                    <div className="form-group mb-3 d-none">
                      <label>Shops</label>
                      {/* <select
                    name="shop_id"
                    value={formData.shop_id}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Shop</option>
                    
                    {filteredShops?.map((item) => (
                      <option key={item.shop_id} value={item.shop_id}>
                        {item?.shop_title}
                      </option>
                    ))}
                  </select> */}
                      <select
                        name="shop_id"
                        value={formData?.shop_id}
                        onChange={handleChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Shop</option>
                        {Shops.map((item) => (
                          <option key={item.shop_id} value={item.shop_id}>
                            {item?.shop_title}
                          </option>
                        ))}
                      </select>
                      {errors.shop_id && (
                        <small className="text-danger">{errors.shop_id}</small>
                      )}
                    </div>
                    <div className="form-group mb-3 d-none">
                      <label>Ware House</label>
                      <select
                        name="warehouse_id"
                        value={formData.warehouse_id}
                        onChange={handleChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Warehouse</option>
                        {warehouse && warehouse.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {errors.warehouse_id && (
                        <small className="text-danger">{errors.warehouse_id}</small>
                      )}
                    </div>
                    <div className="form-group mb-3 d-none">
                      <label>Password</label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                  </>
                )}

                {/* Step 2 Documents rendered unconditionally */}
                {true && (
                  <>
                    <h5 className="mt-4 border-top pt-4 mb-3 text-primary fw-bold" style={{ fontSize: "16px" }}>Upload Document</h5>
                    <div className="row">
                      <div className="col-md-4 form-group mb-3">
                        <label>Title</label>
                        <input
                          type="text"
                          name="title"
                          value={docsData.title}
                          onChange={handleChangeDocs}
                          className="form-control"
                          required
                        />
                        {docserrors.title && (
                          <small className="text-danger">{docserrors.title}</small>
                        )}
                      </div>

                      <div className="col-md-4 form-group mb-3">
                        <label>Issued Date
                        </label>
                        <div className="col-12">
                          <input
                            type="date"
                            name="issued_date"
                            value={docsData.issued_date}
                            onChange={handleChangeDocs}
                            className="form-control"
                          />
                          {docserrors.issued_date && (
                            <small className="text-danger">{docserrors.issued_date}</small>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4 form-group mb-3">
                        <label>Expiry Date</label>
                        <div className="col-12">
                          <input
                            type="date"
                            name="expiry_date"
                            value={docsData.expiry_date}
                            onChange={handleChangeDocs}
                            className="form-control"
                          />
                          {docserrors.expiry_date && (
                            <small className="text-danger">{docserrors.expiry_date}</small>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 form-group mb-3">
                        <label>Upload Document (optional)</label>
                        <input
                          type="file"
                          name="file"
                          accept=".pdf, .doc, .docx, .xls, .xlsx"
                          ref={fileInputRef}
                          onChange={handleChangeDocs}
                          className="form-control"
                        />
                        {docserrors.file && (
                          <small className="text-danger">{docserrors.file}</small>
                        )}


                      </div>

                      <div className="col-md-5 form-group mb-3">
                        <label>Description</label>
                        <input
                          type="text"
                          name="description"
                          value={docsData.description}
                          onChange={handleChangeDocs}
                          className="form-control"
                        />
                      </div>

                      <div className="col-md-2 form-group mb-3">
                        <label> .</label>
                        <button type="button" className="btn btn-secondary form-control" onClick={() => { handleAddDocsRow() }}>
                          Add
                        </button>
                      </div>
                    </div>

                    <div>
                      <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Issued Date</th>
                            <th>Expiry Date</th>
                            <th>File</th>
                            <th>-</th>
                          </tr>
                        </thead>
                        <tbody>
                          {documentData?.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.title}</td>
                              <td>{item?.issued_date}</td>
                              <td>{item?.expiry_date}</td>
                              <td>{item?.file?.name ? item.file.name : "No File"}</td>
                              <td>
                                <img src="/assets/images/icons/delete.png"
                                  className='m-1'
                                  onClick={() => handleRemoveRow(index)}
                                  width={"20px"} />
                              </td>
                            </tr>
                          ))}
                        </tbody>

                      </table>
                      <div className="text-center mt-3">
                        {errors.documentData && (
                          <small className="text-danger">{errors.documentData}</small>
                        )}
                      </div>
                    </div>

                  </>
                )}

              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => handleCancel()}>
                  Cancel
                </button>
                <button type="button" className="btn btn-success" onClick={() => handleSubmit()}>
                  Add
                </button>

                {/* Commented out multi-step navigation buttons */}
                {/* 
                {currentStep == 1 && (
                  <button type="button" className="btn btn-secondary" onClick={() => handleCancel()}>
                    Close
                  </button>
                )}
                {currentStep > 1 && (
                  <button type="button" className="btn btn-secondary" onClick={handlePrevious}>
                    Previous
                  </button>
                )}
                {currentStep < 2 && (
                  <button type="button" className="btn btn-success" onClick={handleNext}>
                    Continue
                  </button>
                )}
                {currentStep === 2 && (
                  <button type="button" className="btn btn-success" onClick={() => handleSubmit()}>
                    Add
                  </button>
                )}
                */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const EditUser = ({
  showModal,
  setShowModal,
  fetchUser,
  selectedUser,
}) => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    role_id: "",
    shop_id: "",
    image: "",
    status: "",
    stamp: "",
    sign_image: "",
    id_card_no: "",
    employee_id: "",
    date_join: "",
    designation: "",
  });
  const [roles, setRoles] = useState([]);
  const { showLoader, hideLoader, shopItem, selectedWarehouse } = useContext(WarehouseContext);
  const [imageUrl, setImageUrl] = useState(null);
  const [stampUrl, setStampUrl] = useState(null);
  const [signUrl, setSignUrl] = useState(null);
  const [Shops, setShops] = useState();

  useEffect(() => {
    console.log(apiClient.defaults.baseURL + "/media/" + selectedUser?.stamp);
    console.log(apiClient.defaults.baseURL + "/media/" + selectedUser?.sign_image);
    fetchRoles();
    setFormData({
      ...formData,
      full_name: selectedUser?.full_name,
      email: selectedUser?.email,
      phone: selectedUser?.phone,
      id_card_no: selectedUser?.id_card_no,
      image: apiClient.defaults.baseURL + "/media/" + selectedUser?.image,
      stamp: selectedUser?.stamp ? apiClient.defaults.baseURL + "/media/" + selectedUser?.stamp : '',
      sign_image: selectedUser?.sign_image ? apiClient.defaults.baseURL + "/media/" + selectedUser?.sign_image : '',
      role_id: selectedUser?.role_Id,
      shop_id: selectedUser?.shop_id,
      date_join: selectedUser?.date_join,
      employee_id: selectedUser?.employee_id,
      designation: selectedUser?.designation,
      status: selectedUser?.status?.toString() || "",
    });
    fetchShops()
  }, [selectedUser]);

  const fetchShops = async (page = 1, text = "") => {
    try {
      const response = await getShops(page, text);
      if (response.data && response.data.data) {
        setShops(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file instanceof File) {
        setImageUrl(URL.createObjectURL(file));
        setFormData({
          ...formData,
          image: file, // Save the file object in the form data
        });
      } else {
        toast.error("Please upload a valid image file.");
      }
    }
  };
  const handleStampChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file instanceof File) {
        setStampUrl(URL.createObjectURL(file));
        setFormData({
          ...formData,
          stamp: file, // Save the file object in the form data
        });
      } else {
        toast.error("Please upload a valid stamp file.");
      }
    }
  };
  const handleSignChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file instanceof File) {
        setSignUrl(URL.createObjectURL(file));
        setFormData({
          ...formData,
          sign_image: file, // Save the file object in the form data
        });
      } else {
        toast.error("Please upload a valid Sign file.");
      }
    }
  };

  useEffect(() => {
    if (formData.image) {
      if (formData.image instanceof File) {
        setImageUrl(URL.createObjectURL(formData.image));
      } else {
        setImageUrl(formData.image);
      }
    } else if (selectedUser?.image) {
      setImageUrl(selectedUser?.image);
    }
  }, [formData.image, selectedUser?.image]);

  useEffect(() => {
    if (formData.stamp) {
      if (formData.stamp instanceof File) {
        setStampUrl(URL.createObjectURL(formData.stamp));
      } else {
        setStampUrl(formData.stamp);
      }
    } else if (selectedUser?.stamp) {
      setStampUrl(selectedUser?.stamp);
    }
  }, [formData.stamp, selectedUser?.stamp]);

  useEffect(() => {
    if (formData.sign_image) {
      if (formData.sign_image instanceof File) {
        setSignUrl(URL.createObjectURL(formData.sign_image));
      } else {
        setSignUrl(formData.sign_image);
      }
    } else if (selectedUser?.sign_image) {
      setSignUrl(selectedUser?.sign_image);
    }
  }, [formData.sign_image, selectedUser?.sign_image]);

  const fetchRoles = async () => {
    try {
      const response = await getRoles();
      console.log(response.data);
      setRoles(response.data.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch roles");
    }
  };

  const handleSubmit = async (e) => {
    showLoader()
    // const payload = {
    //   full_name: formData.full_name,
    //   email: formData.email,
    //   phone: formData.phone,
    //   id_card_no: formData.id_card_no,
    //   image: formData.image,

    //   role_Id: formData.role_Id,
    //   shop_id: formData.shop_id,

    //   status: formData.status,
    // };
    const formDataPayload = new FormData();
    var payload = formData;
    payload.shop_id = shopItem?.shop_id || "";
    payload.warehouse_id = selectedWarehouse?.id;
    console.log("Payload", payload)
    const fileKeys = ["image", "sign_image", "stamp"];
    Object.keys(payload).forEach((key) => {
      if (fileKeys.includes(key)) {
        // Ensure it is a file, not a URL or other type
        if (formData[key] instanceof File) {
          formDataPayload.append(key, formData[key]);
        }
      } else if (formData[key] !== null && formData[key] !== undefined) {
        formDataPayload.append(key, formData[key]);
      }
    });

    try {
      await updateUser(selectedUser?.user_Id, formDataPayload);
      hideLoader();
      toast.success("User Updated successfully");
      setShowModal(false);
      fetchUser();

    } catch (error) {
      console.error("Error saving User data:", error);
      hideLoader();
      toast.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
      return;
    }
    //email
    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const emailErrorElement = document.getElementById("emailError");

      if (!emailPattern.test(value)) {
        emailErrorElement.style.display = "block";
      } else {
        emailErrorElement.style.display = "none";
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  Edit User
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <div className="form-group mb-3 d-flex justify-content-center align-items-center">
                  <div
                    className="profile-pic d-flex justify-content-center align-items-center rounded-circle"
                    onClick={() =>
                      document.getElementById("image-upload").click()
                    }
                    style={{
                      width: "100px",
                      height: "100px",
                      overflow: "hidden",
                      border: "2px solid #ccc",
                      cursor: "pointer",
                      backgroundColor: "#f8f8f8",
                    }}
                  >
                    {imageUrl ? (
                      // Display image if imageUrl is set (either new or existing image)
                      <img
                        src={imageUrl}
                        alt="Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      // Default image if no image is set
                      <img
                        src="../../assets/images/profile.png"
                        alt="Default Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    name="image"
                    onChange={handleImageChange}
                    className="form-control d-none"
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Employee ID</label>
                  <input
                    type="text"
                    name="employee_id"
                    value={formData.employee_id}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label>FullName</label>
                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                  />
                  <small
                    id="emailError"
                    className="text-danger"
                    style={{ display: "none" }}
                  >
                    Please enter a valid email.
                  </small>
                </div>

                <div className="form-group mb-3">
                  <label>Phone</label>
                  <input
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Date Of Join</label>
                  <input
                    type="date"
                    name="date_join"
                    value={formatDate2(formData.date_join)}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        ["date_join"]: formatDate(e.target.value),
                      });
                    }}
                    className="form-control"
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Designation</label>
                  <input
                    type="text"
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="form-group mb-3">
                  <label>ID Card Number</label>
                  <input
                    type="text"
                    name="id_card_no"
                    value={formData.id_card_no}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label>Role</label>
                  <select
                    name="role_id"
                    value={formData.role_id}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role.role_id} value={role.role_id}>
                        {role.role_title}
                      </option>
                    ))}
                  </select>
                </div>
                {formData.role_id == 1 &&
                  <>
                    <div className="row">
                      <div className="form-group flex-column col-6 mb-3 d-flex justify-content-center align-items-center">
                        <label>Stamp</label>
                        <div
                          className="profile-pic d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() =>
                            document.getElementById("stamp-upload").click()
                          }
                          style={{
                            width: "100px",
                            height: "100px",
                            overflow: "hidden",
                            border: "2px solid #ccc",
                            cursor: "pointer",
                            backgroundColor: "#f8f8f8",
                          }}
                        >
                          {stampUrl ? (
                            // Display image if imageUrl is set (either new or existing image)
                            <img
                              src={stampUrl}
                              alt="Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            // Default image if no image is set
                            <img
                              src="../../assets/images/profile.png"
                              alt="Default Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>
                        <input
                          id="stamp-upload"
                          type="file"
                          accept="image/*"
                          name="stamp"
                          onChange={handleStampChange}
                          className="form-control d-none"
                        />
                      </div>
                      <div className="form-group flex-column col-6 mb-3 d-flex justify-content-center align-items-center">
                        <label>Signature</label>
                        <div
                          className="profile-pic d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() =>
                            document.getElementById("sign-upload").click()
                          }
                          style={{
                            width: "100px",
                            height: "100px",
                            overflow: "hidden",
                            border: "2px solid #ccc",
                            cursor: "pointer",
                            backgroundColor: "#f8f8f8",
                          }}
                        >
                          {signUrl ? (
                            // Display image if imageUrl is set (either new or existing image)
                            <img
                              src={signUrl}
                              alt="Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            // Default image if no image is set
                            <img
                              src="../../assets/images/profile.png"
                              alt="Default Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>
                        <input
                          id="sign-upload"
                          type="file"
                          accept="image/*"
                          name="sign_image"
                          onChange={handleSignChange}
                          className="form-control d-none"
                        />
                      </div>
                    </div>
                  </>

                }

                <div className="form-group mb-3 d-none">
                  <label>Shops</label>
                  <select
                    name="shop_id"
                    value={formData?.shop_id}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Shop</option>
                    {Shops.map((item) => (
                      <option key={item?.shop_id} value={item?.shop_id}>
                        {item?.shop_title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group mb-3">
                  <label>Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="" disabled selected>
                      Select Status
                    </option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className="btn btn-success float-end"
                  onClick={() => handleSubmit()}
                >
                  Update User
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-secondary ml-2 float-end me-1"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
